import create from "zustand";
export const useStore = create((set, get) => ({
  filteredProducts: [],
  // Gender
  unisex: false,
  women: false,
  men: false,
  girls: false,
  boys: false,
  // Colour
  lightGrey: false,
  orange: false,
  darkOrange: false,
  grey: false,
  green: false,
  darkGrey: false,
  lightBlue: false,
  blue: false,
  darkBlue: false,
  lightRed: false,
  red: false,
  lightPink: false,
  pink: false,
  lightGreen: false,
  lightWhite: false,
  white: false,
  silver: false,
  black: false,
  charcoal: false,
  purple: false,
  darkPurple: false,
  yellow: false,
  darkOrange: false,
  // Price
  r0_r5000: false,
  r5000_r10000: false,
  r10000_r15000: false,
  r15000_r20000: false,
  r15000_r20000: false,
  r20000_r25000: false,
  r25000_r30000: false,
  r30000_r35000: false,
  r35000_r40000: false,
  r40000_r45000: false,
  r45000_r50000: false,
  // Bike Size
  extraSmall: false,
  small: false,
  medium: false,
  large: false,
  extraLarge: false,
  size12: false,
  size13half: false,
  size14: false,
  size16: false,
  size20: false,
  size24: false,
  xs_wheel_27_5: false,
  sm_wheel_27_5: false,
  xxl_wheel_29: false,
  s_wheel_29: false,
  m_wheel_27_5: false,
  l_wheel_27_5: false,
  l_wheel_29: false,
  xl_wheel_29: false,
  m_wheel_29: false,
  // Wheel Size
  wheelSize12: false,
  wheelSize14: false,
  wheelSize16: false,
  wheelSize20: false,
  wheelSize24: false,
  wheelSize26: false,
  wheelSize29: false,
  wheelSize700c: false,
  // Filter Categories
  genderToggle: false,
  wheelSizeToggle: false,
  categoryToggle: false,
  sizeToggle: false,
  colourToggle: false,
  priceToggle: false,
  // categoryToggle: false,

  getGenders: (products) => {
    const tags = [];
    products.tags.map((tag) => {
      tag.find((item) => item.includes(""));
      tags.push({
        name: tag.split(":")[1].charAt(0).toUpperCase(),
        criteria: "",
      });
    });
  },
  setToggle: (payload) => {
    payload.name === "gender"
      ? set({ genderToggle: payload.value })
      : payload.name === "category"
      ? set({ categoryToggle: payload.value })
      : payload.name === "size"
      ? set({ sizeToggle: payload.value })
      : payload.name === "colour"
      ? set({ colourToggle: payload.value })
      : payload.name === "price"
      ? set({ priceToggle: payload.value })
      : null;
  },
  getFiltersByUrl: (payload) => {
    //TODO: loop through filters in query parametres and add the filters per criteria
    payload.map((filter) => {
      get().addToFilter(filter);
    });
  },
  addToFilter: (payload) => {
    let newfilteredProducts = null;
    if (payload.category === "Gender" || payload.category === "Wheel Size") {
      newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf(payload.criteria) > -1;
      });
    }
    if (payload.category === "Colour") {
      newfilteredProducts = payload.products.filter((product) => {
        if (product.tags.includes(payload.colour.primary)) {
          return product.tags.indexOf(payload.colour.primary) > -1;
        } else if (product.tags.includes(payload.colour.secondary)) {
          return product.tags.indexOf(payload.colour.secondary) > -1;
        }
      });
    }
    if (payload.category === "Bike Size") {
      newfilteredProducts = payload.products.filter((product) => {
        return product.options[1].values.indexOf(payload.size) > -1;
      });
    }
    if (payload.category === "Price") {
      newfilteredProducts = payload.products.filter((product) => {
        const price = parseInt(product.priceRange.maxVariantPrice.amount);
        return payload.price.min <= price && payload.price.max >= price;
      });
    }
    const combinedFilteredProducts = [
      ...get().filteredProducts,
      ...newfilteredProducts,
    ];
    let distinctProducts = [];
    combinedFilteredProducts.map((x) =>
      distinctProducts.filter((a) => a.handle == x.handle).length > 0
        ? null
        : distinctProducts.push(x)
    );
    set({ filteredProducts: distinctProducts });
  },
  removeFromFilter: (payload) => {
    let combinedFilteredProducts = [];
    let distinctProducts = [];
    set({ filteredProducts: [] });
    // Gender
    if (payload.criteria !== "gender:unisex" && get().unisex) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("gender:unisex") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "gender:women" && get().women) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("gender:women") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "gender:men" && get().men) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("gender:men") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "gender:girls" && get().girls) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("gender:girls") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "gender:boys" && get().boys) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("gender:boys") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (
      !get().unisex &&
      !get().women &&
      !get().men &&
      !get().girls &&
      !get().boys
    ) {
      set({ genderToggle: false });
    }
    // Wheel Size
    if (payload.criteria !== "wheel_size:12" && get().wheelSize12) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("wheel_size:12") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "wheel_size:14" && get().wheelSize14) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("wheel_size:14") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "wheel_size:16" && get().wheelSize16) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("wheel_size:16") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "wheel_size:20" && get().wheelSize20) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("wheel_size:20") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "wheel_size:24" && get().wheelSize24) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("wheel_size:24") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "wheel_size:26" && get().wheelSize26) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("wheel_size:26") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "wheel_size:29" && get().wheelSize29) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("wheel_size:29") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (payload.criteria !== "wheel_size:700c" && get().wheelSize700c) {
      const newfilteredProducts = payload.products.filter((product) => {
        return product.tags.indexOf("wwheel_size:700c") > -1;
      });
      combinedFilteredProducts = [
        ...combinedFilteredProducts,
        ...newfilteredProducts,
      ];
    }
    if (
      !get().wheelSize12 &&
      !get().wheelSize14 &&
      !get().wheelSize16 &&
      !get().wheelSize20 &&
      !get().wheelSize24 &&
      !get().wheelSize26 &&
      !get().wheelSize29 &&
      !get().wheelSize700c
    ) {
      set({ wheelSizeToggle: false });
    }
    // Remove duplicates
    combinedFilteredProducts.map((x) =>
      distinctProducts.filter((a) => a.handle == x.handle && a.title == x.title)
        .length > 0
        ? null
        : distinctProducts.push(x)
    );
    set({ filteredProducts: distinctProducts });
  },
  filter: (payload) => {
    switch (payload.criteria) {
      // Genders
      case "gender:unisex":
        payload.category = "Gender";
        if (!get().unisex) {
          set({ unisex: true });
          set({ genderToggle: true });
          get().addToFilter(payload);
        } else {
          set({ unisex: false });
          get().removeFromFilter(payload);
        }
        break;
      case "gender:women":
        payload.category = "Gender";
        if (!get().women) {
          set({ women: true });
          set({ genderToggle: true });
          get().addToFilter(payload);
        } else {
          set({ women: false });
          set({ genderToggle: true });
          get().removeFromFilter(payload);
        }
        break;
      case "gender:men":
        payload.category = "Gender";
        if (!get().men) {
          set({ men: true });
          set({ genderToggle: true });
          get().addToFilter(payload);
        } else {
          set({ men: false });
          get().removeFromFilter(payload);
        }
        break;
      case "gender:girls":
        payload.category = "Gender";
        if (!get().girls) {
          set({ girls: true });
          set({ genderToggle: true });
          get().addToFilter(payload);
        } else {
          set({ girls: false });
          get().removeFromFilter(payload);
        }
        break;
      case "gender:boys":
        payload.category = "Gender";
        if (!get().boys) {
          set({ boys: true });
          set({ genderToggle: true });
          get().addToFilter(payload);
        } else {
          set({ boys: false });
          get().removeFromFilter(payload);
        }
        break;
      // Colour
      case "colour:light grey":
        console;
        payload.category = "Colour";
        if (!get().lightGrey) {
          set({ lightGrey: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ lightGrey: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:grey":
        payload.category = "Colour";
        if (!get().grey) {
          set({ grey: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ grey: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:dark grey":
        payload.category = "Colour";
        if (!get().darkGrey) {
          set({ darkGrey: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ darkGrey: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:light blue":
        payload.category = "Colour";
        if (!get().lightBlue) {
          set({ lightBlue: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ lightBlue: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:blue":
        payload.category = "Colour";
        if (!get().blue) {
          set({ blue: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ blue: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:dark blue":
        payload.category = "Colour";
        if (!get().darkBlue) {
          set({ darkBlue: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ darkBlue: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:light red":
        payload.category = "Colour";
        if (!get().lightRed) {
          set({ lightRed: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ lightRed: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:red":
        payload.category = "Colour";
        if (!get().red) {
          set({ red: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ red: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:light pink":
        payload.category = "Colour";
        if (!get().lightPink) {
          set({ lightPink: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ lightPink: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:pink":
        payload.category = "Colour";
        if (!get().pink) {
          set({ pink: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ pink: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:light green":
        payload.category = "Colour";
        if (!get().lightGreen) {
          set({ lightGreen: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ lightGreen: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:light white":
        payload.category = "Colour";
        if (!get().lightWhite) {
          set({ lightWhite: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ lightWhite: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:white":
        payload.category = "Colour";
        if (!get().white) {
          set({ white: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ white: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:silver":
        payload.category = "Colour";
        if (!get().silver) {
          set({ silver: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ silver: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:black":
        payload.category = "Colour";
        if (!get().black) {
          set({ black: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ black: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:charcoal":
        payload.category = "Colour";
        if (!get().charcoal) {
          set({ charcoal: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ charcoal: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:purple":
        payload.category = "Colour";
        if (!get().purple) {
          set({ purple: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ purple: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:dark purple":
        payload.category = "Colour";
        if (!get().darkPurple) {
          set({ darkPurple: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ darkPurple: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:yellow":
        payload.category = "Colour";
        if (!get().yellow) {
          set({ yellow: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ yellow: false });
          get().removeFromFilter(payload);
        }
        break;
      // Giordi piece of code
      case "colour:green":
        payload.category = "Colour";
        if (!get().green) {
          set({ green: true });
          set({ colourToggle: true });
          // wjat does color toggle do? and does it get set to false
          get().addToFilter(payload);
        } else {
          set({ green: false });
          get().removeFromFilter(payload);
        }
        break;
      case "colour:dark orange":
        payload.category = "Colour";
        if (!get().darkOrange) {
          set({ darkOrange: true });
          set({ colourToggle: true });
          get().addToFilter(payload);
        } else {
          set({ darkOrange: false });
          get().removeFromFilter(payload);
        }
        break;
      // Price
      case "price:0-5000":
        payload.category = "Price";
        if (!get().r0_r5000) {
          set({ r0_r5000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r0_r5000: false });
          get().removeFromFilter(payload);
        }
        break;
      case "price:5000-10000":
        payload.category = "Price";
        if (!get().r5000_r10000) {
          set({ r5000_r10000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r5000_r10000: false });
          get().removeFromFilter(payload);
        }
        break;
      case "price:10000-15000":
        payload.category = "Price";
        if (!get().r10000_r15000) {
          set({ r10000_r15000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r10000_r15000: false });
          get().removeFromFilter(payload);
        }
        break;
      case "price:15000-20000":
        payload.category = "Price";
        if (!get().r15000_r20000) {
          set({ r15000_r20000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r15000_r20000: false });
          get().removeFromFilter(payload);
        }
        break;
      case "price:20000-25000":
        payload.category = "Price";
        if (!get().r20000_r25000) {
          set({ r20000_r25000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r20000_r25000: false });
          get().removeFromFilter(payload);
        }
        break;
      case "price:25000-30000":
        payload.category = "Price";
        if (!get().r25000_r30000) {
          set({ r25000_r30000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r25000_r30000: false });
          get().removeFromFilter(payload);
        }
        break;
      case "price:30000-35000":
        payload.category = "Price";
        if (!get().r30000_r35000) {
          set({ r30000_r35000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r30000_r35000: false });
          get().removeFromFilter(payload);
        }
        break;
      case "price:35000-40000":
        payload.category = "Price";
        if (!get().r35000_r40000) {
          set({ r35000_r40000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r35000_r40000: false });
          get().removeFromFilter(payload);
        }
        break;
      case "price:40000-45000":
        payload.category = "Price";
        if (!get().r40000_r45000) {
          set({ r40000_r45000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r40000_r45000: false });
          get().removeFromFilter(payload);
        }
        break;
      case "price:45000-50000":
        payload.category = "Price";
        if (!get().r45000_r50000) {
          set({ r45000_r50000: true });
          set({ priceToggle: true });
          get().addToFilter(payload);
        } else {
          set({ r45000_r50000: false });
          get().removeFromFilter(payload);
        }
        break;
      // Bike Sizes
      case "size:xs":
        payload.category = "Bike Size";
        if (!get().extraSmall) {
          set({ extraSmall: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ extraSmall: false });
          get().removeFromFilter(payload);
        }
        break;
      case "size:S":
        payload.category = "Bike Size";
        if (!get().small) {
          set({ small: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ small: false });
          get().removeFromFilter(payload);
        }
        break;
      case "size:M":
        payload.category = "Bike Size";
        if (!get().medium) {
          set({ medium: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ medium: false });
          get().removeFromFilter(payload);
        }
        break;
      case "size:L":
        payload.category = "Bike Size";
        if (!get().large) {
          set({ large: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ large: false });
          get().removeFromFilter(payload);
        }
        break;
      case "size:XL":
        payload.category = "Bike Size";
        if (!get().extraLarge) {
          set({ extraLarge: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ extraLarge: false });
          get().removeFromFilter(payload);
        }
        break;
      // Wheel Size
      // TODO cross check this size ?
      case "size:12":
        payload.category = "Bike Size";
        if (!get().size12) {
          set({ size12: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ size12: false });
          get().removeFromFilter(payload);
        }
        break;
      case "size:13.5":
        payload.category = "Bike Size";
        if (!get().size13half) {
          set({ size13half: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ size13half: false });
          get().removeFromFilter(payload);
        }
        break;
      case "size:14":
        payload.category = "Bike Size";
        if (!get().size14) {
          set({ size14: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ size14: false });
          get().removeFromFilter(payload);
        }
        break;
      case "size:16":
        payload.category = "Bike Size";
        if (!get().size16) {
          set({ size16: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ size16: false });
          get().removeFromFilter(payload);
        }
        break;
      case "size:20":
        payload.category = "Bike Size";
        if (!get().size20) {
          set({ size20: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ size20: false });
          get().removeFromFilter(payload);
        }
        break;
      case "size:24":
        payload.category = "Bike Size";
        if (!get().size24) {
          set({ size24: true });
          set({ sizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ size24: false });
          get().removeFromFilter(payload);
        }
        break;
      // Wheel Sizes
      case "wheel_size:12":
        payload.category = "Wheel Size";
        if (!get().wheelSize12) {
          set({ wheelSize12: true });
          set({ wheelSizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ wheelSize12: false });
          get().removeFromFilter(payload);
        }
        break;
      case "wheel_size:14":
        payload.category = "Wheel Size";
        if (!get().wheelSize14) {
          set({ wheelSize14: true });
          set({ wheelSizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ wheelSize14: false });
          get().removeFromFilter(payload);
        }
        break;
      case "wheel_size:16":
        payload.category = "Wheel Size";
        if (!get().wheelSize16) {
          set({ wheelSize16: true });
          set({ wheelSizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ wheelSize16: false });
          get().removeFromFilter(payload);
        }
        break;
      case "wheel_size:20":
        payload.category = "Wheel Size";
        if (!get().wheelSize20) {
          set({ wheelSize20: true });
          set({ wheelSizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ wheelSize20: false });
          get().removeFromFilter(payload);
        }
        break;
      case "wheel_size:24":
        payload.category = "Wheel Size";
        if (!get().wheelSize24) {
          set({ wheelSize24: true });
          set({ wheelSizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ wheelSize24: false });
          get().removeFromFilter(payload);
        }
        break;
      case "wheel_size:26":
        payload.category = "Wheel Size";
        if (!get().wheelSize26) {
          set({ wheelSize26: true });
          set({ wheelSizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ wheelSize26: false });
          get().removeFromFilter(payload);
        }
        break;
      case "wheel_size:29":
        payload.category = "Wheel Size";
        if (!get().wheelSize29) {
          set({ wheelSize29: true });
          set({ wheelSizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ wheelSize29: false });
          get().removeFromFilter(payload);
        }
        break;
      case "wheel_size:700c":
        payload.category = "Wheel Size";
        if (!get().wheelSize700c) {
          set({ wheelSize700c: true });
          set({ wheelSizeToggle: true });
          get().addToFilter(payload);
        } else {
          set({ wheelSize700c: false });
          get().removeFromFilter(payload);
        }
        break;
    }
  },
}));
